import { render, staticRenderFns } from "./ChoiceQuestionRange.vue?vue&type=template&id=4b13fca6&scoped=true"
import script from "./ChoiceQuestionRange.vue?vue&type=script&lang=js"
export * from "./ChoiceQuestionRange.vue?vue&type=script&lang=js"
import style0 from "./ChoiceQuestionRange.vue?vue&type=style&index=0&id=4b13fca6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b13fca6",
  null
  
)

export default component.exports